import styled from 'styled-components';
import { BoxRemove as MaterialBoxRemove } from '../../../../styles/icons';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const BoxRemove = styled(MaterialBoxRemove)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;
